/* eslint react/button-has-type:0 */
import React from 'react';
import PropTypes from 'prop-types';
import classes from './Button.module.scss';

const Button = ({ children, ...otherProps }) => (
  <div className={classes.buttonContainer}>
    <button className={classes.button} {...otherProps}>
      {children}
    </button>
  </div>
);

Button.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Button;
